import React, {Component, useContext, useState} from 'react';
import GettingStartedContext from "../utils/GettingStartedContext";

const QNumbers = () => {

  const {
    data,
    showResult,
    question,
    submittedQuestions,
    setQuestion,
    indexOfSubmittedQuestion,
    selectTestimonials,
    setLocation
  } = useContext(GettingStartedContext)

  const padLeadingZeros = (num, size) => {
    let s = num+"";
    while (s.length < size) s = "0" + s;
    return s;
  }

  const changeActiveQuestion = (q) => {

    if (q.Pos < question.Pos) {

      const index = indexOfSubmittedQuestion(q);
      const submittedQuestion = submittedQuestions[index];

      if (q.ClassName === "App\\Model\\DepartureLocationQuestion") {
        setLocation(submittedQuestion.Option);
      }
      setQuestion(submittedQuestion);
      selectTestimonials();
    }

  };

  if (showResult) {
    return null;
  }

  return <div className="gsa__index">
    <ul>
      {data.Questions.map((q, index) => {
        let qClass = '';
        if (q.Pos === question.Pos) {
          qClass = 'active'
        } else if (q.Pos <= question.Pos) {
          qClass = 'visited'
        }
        return <li key={index} onClick={() => changeActiveQuestion(q)}>
          <a className={qClass}>
            {padLeadingZeros(index+1, 2)}
          </a>
        </li>
      })}
    </ul>
  </div>
}

export default QNumbers;
